export default __webpack_public_path__ + "static/media/screenShots_delivery-2.c49e6da1.jpg";